module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01-m-en.9173fe4400edc49dd55857015aa9c5b3.png";